<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Withdraw cash</h1>
    <CashCreditForm :action_text="0"/>
  </v-card>
</template>

<script>

import axios from "axios";
import { mapState } from "vuex";
import CashCreditForm from "@/components/back-office/Rider/CashCreditForm";
export default {
  data() {
    return {};
  },
  components: {
    CashCreditForm
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Withdraw money",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {}
};
</script>
